import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";
import { AvatarListRes } from "../../types/ResType";

export const useAvtarList = () => {
  return useQuery<AvatarListRes, Error>(
    ["avatar/get-all-avatars"],
    async () => {
      const response = await axiosInstance.get<AvatarListRes>("avatar/get-all-avatars");
      return response.data;
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  );
};
